module.exports = __webpack_public_path__ + "img/projetIcon.e5aef275.png";